/**
 * Staged-apply behavior for the collection filter drawer.
 *
 * The existing theme.js binds an `input`-event handler to `.filter-form` that
 * auto-submits the form (navigating to the filtered URL) on every checkbox
 * change. This file overrides that for `.filter-form--staged`: it stops
 * propagation in the capture phase, stages selections locally, updates the
 * apply button's count, and only navigates when the user clicks apply.
 *
 * If JS fails to load, the auto-submit-on-change fallback still works.
 */
(function () {
  'use strict';

  var DRAWER_SELECTOR = '[data-filter-drawer]';
  var FORM_SELECTOR = '[data-staged-filters]';
  var INPUT_SELECTOR = '[data-filter-input]';
  var APPLY_SELECTOR = '[data-filter-apply]';
  var APPLY_COUNT_SELECTOR = '[data-filter-apply-count]';
  var CLEAR_SELECTOR = '[data-filter-clear]';

  function init() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    var form = drawer.querySelector(FORM_SELECTOR);
    if (!form) return;

    var applyBtn = drawer.querySelector(APPLY_SELECTOR);
    var applyCount = drawer.querySelector(APPLY_COUNT_SELECTOR);
    var clearBtn = drawer.querySelector(CLEAR_SELECTOR);

    // Capture-phase listener — runs before theme.js's bubbling `input` handler
    // and prevents the auto-submit. Same for `change`.
    function stopAutoSubmit(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest(FORM_SELECTOR)) return;
      e.stopPropagation();
      updateApplyCount();
    }
    form.addEventListener('input', stopAutoSubmit, true);
    form.addEventListener('change', stopAutoSubmit, true);

    // Prevent native form submission as a final safety net.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      navigateToStagedUrl();
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        navigateToStagedUrl();
      });
    }

    if (clearBtn) {
      // clear-all is an <a href> to the base collection URL, so default nav is
      // already correct — no JS intervention needed unless we want to preserve
      // sort. Preserve sort_by if present in the current URL.
      clearBtn.addEventListener('click', function (e) {
        var sortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (sortBy) {
          e.preventDefault();
          var base = clearBtn.getAttribute('href') || window.location.pathname;
          var sep = base.indexOf('?') === -1 ? '?' : '&';
          window.location.href = base + sep + 'sort_by=' + encodeURIComponent(sortBy);
        }
      });
    }

    function getCheckedCount() {
      var inputs = form.querySelectorAll(INPUT_SELECTOR);
      var n = 0;
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        if (el.type === 'checkbox' || el.type === 'radio') {
          if (el.checked) n++;
        }
      }
      return n;
    }

    function updateApplyCount() {
      var n = getCheckedCount();
      if (applyBtn) applyBtn.setAttribute('data-count', String(n));
      if (applyCount) {
        applyCount.textContent = '(' + n + ')';
        if (n === 0) applyCount.setAttribute('hidden', '');
        else applyCount.removeAttribute('hidden');
      }
    }

    function navigateToStagedUrl() {
      var params = new URLSearchParams();

      // Preserve current sort and any non-filter params (search q, etc.)
      var existing = new URLSearchParams(window.location.search);
      existing.forEach(function (value, key) {
        if (key.indexOf('filter.') !== 0) {
          params.set(key, value);
        }
      });

      // Append staged filter values
      var inputs = form.querySelectorAll(INPUT_SELECTOR);
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        if (!el.name) continue;
        if (el.type === 'checkbox' || el.type === 'radio') {
          if (el.checked) params.append(el.name, el.value);
        } else if (el.value !== '') {
          // price range min/max
          params.set(el.name, el.value);
        }
      }

      var qs = params.toString();
      var base = window.location.pathname;
      window.location.href = qs ? base + '?' + qs : base;
    }

    // Initial sync (active filters baked into the rendered HTML)
    updateApplyCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
